<template>
  <div class="armada">
    <div class="flex justify-between items-center pb-6 shadow-border-b mdmax:flex-col mdmax:shadow-none">
      <div class="flex-1 mdmax:flex-auto mdmax:w-full mdmax:mb-2">
        <LinkButton buttonText="Tambah Armada" url="/armada/create" linkType="internal" :size="isMobile ? 'full' : 'regular'" />
      </div>
      <div class="flex-1 flex justify-end gap-8 mdmax:flex-col mdmax:flex-auto mdmax:w-full mdmax:gap-2">
        <div class="w-2/5 mdmax:w-full">
          <label class="text-base text-neutral-700 font-medium mb-1 inline-block">Tipe Aset</label>
          <CustomSelect :options="ownershipTypes" v-model="selectedType" optionLabel="ownership_type" />
        </div>
        <div class="w-3/5 mdmax:w-full">
          <label class="text-base text-neutral-700 font-medium mb-1 inline-block">Pencarian</label>
          <div class="relative">
            <TextField type="text" :withIcon="true" placeholder="Plat armada, asset owner, no kontak" />
            <div class="absolute left-3 top-1/2 transform -translate-y-1/2">
              <Search />
            </div>
          </div>
        </div>
      </div>
    </div>
    <TableComponent :columns="columns" :list="filteredData">
      <template slot="table-row" slot-scope="{ entry, column }">
        <LinkButton v-if="column.field === 'action'" buttonText="Lihat rincian" :url="`/armada/detail/${entry.id}`" linkType="internal" type="secondary" size="small" />
        <span class="block" v-else-if="column.field === 'vehicle_name'">
          {{ entry[column.field] }}
          <span class="block text-xs text-neutral-500">{{ entry.vehicle_production_year }}</span>
        </span>
        <span class="block" v-else-if="column.field === 'ownership_assigned'">
          {{ entry[column.field].name || '-' }}
        </span>
        <span class="block" v-else-if="column.field === 'phone_number'">
          {{ entry['ownership_assigned'].phone_number || '-' }}
        </span>
        <span class="block" v-else-if="column.field === 'created_at'">
          {{ entry[column.field] | formatDate }}
        </span>
        <span v-else class="capitalize">{{ entry[column.field] }}</span>
      </template>
    </TableComponent>
    <div class="text-neutral-500 font-medium mt-2 text-sm" v-if="!isMobile">Menampilkan {{ start }} - {{ end }} dari {{ totalRecords }}</div>
    <div class="mt-8 flex justify-center items-center mb-6" v-if="filteredData && filteredData.length > 0">
      <pagination :currentPage="currentPage" :totalCount="totalRecords" :pageSize="pageSize" @onPageChange="onPageChange" />
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { formatDate } from '@/util'
export default {
  filters: {
    formatDate
  },
  components: {
    CustomSelect: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/CustomSelect'),
    TextField: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/TextField'),
    LinkButton: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/LinkButton'),
    Search: () => import(/* webpackChunkName: "icon" */ '@/components/Icons/Search'),
    Pagination: () => import(/* webpackChunkName: "Pagination" */ '@/components/Pagination/Pagination'),
    TableComponent: () => import(/* webpackChunkName: "Table" */ '@/components/Table/Table')
  },
  data: () => ({
    typeList: ['Semua', 'Pickup', 'Pengiriman'],
    selectedType: '',
    columns: [
      // { label: 'ID', field: 'id' },
      { label: 'Tanggal', field: 'created_at' },
      { label: 'Nama Armada', field: 'vehicle_name' },
      { label: 'Aset', field: 'ownership_type' },
      { label: 'Plat Armada', field: 'vehicle_plat_id' },
      { label: 'Aset Owner', field: 'ownership_assigned' },
      { label: 'No Kontak', field: 'phone_number' },
      { label: 'Action', field: 'action' }
    ],
    data: [
      {
        id: '001',
        date: '16 Oct 2021',
        name: 'Mitsubisi Colt 110PS',
        year: '2018',
        asetType: 'Partner',
        plat: 'B 2312 TI',
        asetOwner: 'Pipit Sapitri',
        contact: '098988287789'
      },
      {
        id: '002',
        date: '16 Oct 2021',
        name: 'Mitsubisi Colt 110PS',
        year: '2018',
        asetType: 'Partner',
        plat: 'B 2312 TI',
        asetOwner: 'Pipit Sapitri',
        contact: '098988287789'
      }
    ],
    searchTerm: '',
    totalRecords: 0,
    currentPage: 1,
    pageSize: 10,
    hasMorePages: true
  }),
  computed: {
    ...mapGetters('common', ['isMobile']),
    ...mapGetters('auth', ['userData']),
    ...mapGetters('armada', ['armada']),
    ...mapGetters('master', ['ownershipTypes']),
    filteredData() {
      let temp = this.armada || []
      temp = temp.filter(item => {
        return item.id !== ''
      })
      return temp
    },
    start() {
      return (this.currentPage - 1) * this.pageSize + 1
    },
    end() {
      const lastOnPage = (this.currentPage - 1) * this.pageSize + this.pageSize
      return lastOnPage > this.totalRecords ? this.totalRecords : lastOnPage
    }
  },
  created() {
    this.getOwnership()
    if (!this.$route.query.page) {
      this.$router.push({ path: '/armada', query: { page: 1 } })
      this.page = 1
      this.currentPage = 1
    } else {
      this.page = parseInt(this.$route.query.page)
      this.currentPage = parseInt(this.$route.query.page)
      this.getArmadaList()
    }
  },
  watch: {
    $route(val) {
      if (val.query.page) {
        this.page = parseInt(val.query.page)
        this.currentPage = parseInt(val.query.page)
        this.getArmadaList()
      } else {
        this.$router.push({ path: '/armada', query: { page: 1 } })
        this.page = 1
        this.currentPage = 1
      }
    }
  },
  methods: {
    ...mapActions('armada', ['getArmada']),
    ...mapActions('common', ['showLoading', 'hideLoading']),
    ...mapActions('master', ['getOwnershipTypes']),
    getOwnership() {
      this.getOwnershipTypes()
    },
    getArmadaList(searchTerm = '') {
      this.showLoading()
      const partnerId = this.userData?.user?.group_id

      this.getArmada({
        partnerId: partnerId,
        params: {
          page: this.currentPage,
          per_page: this.pageSize,
          search_keyword: searchTerm,
          sort: 'DESC'
        }
      })
        .then(res => {
          this.totalRecords = res.data.meta.total_item
          this.hideLoading()
        })
        .catch(() => {
          this.hideLoading()
        })
    },
    onPageChange(page) {
      this.currentPage = page
      this.$router.push({ path: '/armada', query: { page: page } })
    },
    doSearch() {
      this.getArmadaList(this.searchTerm)
    },
    showMore(page) {
      this.$router.push({ path: '/armada', query: { page: page } })
      this.page = page
      this.currentPage = page
    },
    goToDetail(target) {
      this.$router.push(`/armada/detail/${target}`)
    }
  }
}
</script>
